const defaultSeo = {
    en: {
        title: "Battle of the Huns",
        description: "Experience the trills of the Battle of the Huns with interactive tasks.",
    },
    hu: {
        title: "Hunok csatája",
        description: "Éld át a hunok csatájának izgalmát interaktív játékos feladatokon keresztül!",
    },
    image: "/battle-of-the-huns/images/facebook-image.jpg",
};

export default defaultSeo;
